var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "NotificationHandler",
    class: _vm.isWidest ? 'mr-3' : 'mr-2',
    attrs: {
      "id": "NotificationHandler"
    },
    on: {
      "mousedown": function ($event) {
        return _vm.toggleNotifications();
      }
    }
  }, [_c('r-icon', {
    staticClass: "mt-1",
    attrs: {
      "icon": "notifications",
      "size": "16",
      "fill": "harakiri"
    }
  }), _vm.count !== '0' ? _c('div', {
    staticClass: "bulb briscola white--text fargo--bg"
  }, [_vm._v(" " + _vm._s(_vm.count) + " ")]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }